<template>
  <div>
    <div class="row">
      <div class="small-12 medium-4 columns">
        <label>Age</label>
      </div>

      <div class="medium-6 columns">
        <slider :property="AgeNow" @update="setAgeNow($event.values[0])"></slider>
      </div>

      <div class="small-12 medium-2 columns">
        <custom-input type="number" :property="AgeNow" @change="setAgeNow($event.target.value)"></custom-input>
      </div>
    </div>

    <div class="row">
      <div class="small-12 medium-4 large-3 columns">
        <label>Gender</label>
      </div>

      <div class="medium-8 large-7 columns text-right">
        <checkbox name="gender" :items="genders" :selected="Sex" @change="setSex($event.value)"></checkbox>
      </div>

      <div class="show-for-large large-2 columns"></div>
    </div>

    <div class="row">
      <div class="small-12 medium-4 columns">
        <label>Annual salary <help-icon place="top-right" :message="salaryHelpMessage" :is-error="salaryError" :error-message="salaryErrorMessage"></help-icon></label>
      </div>

      <div class="medium-6 columns">
        <slider :property="Salary" @update="setSalary($event.values[0])"></slider>
      </div>

      <div class="small-12 medium-2 columns">
        <custom-input type="number" filter="currencyDisplay" :property="Salary" @change="setSalary($event.target.value)"></custom-input>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Constants } from '@/constants';

export default {
  props: {
    modifier: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      genders: {
        male: {
          value: 'Male',
          text: 'Male',
          icon: require('!html-loader!@/assets/male.svg'),
        },
        female: {
          value: 'Female',
          text: 'Female',
          icon: require('!html-loader!@/assets/female.svg'),
        },
      },
    };
  },
  computed: {
    ...mapState(['inputs', 'inferred']),
    AgeNow() {
      return this.inputs[`AgeNow${this.modifier}`];
    },
    Sex() {
      return this.inputs[`Sex${this.modifier}`];
    },
    Salary() {
      return this.inferred[`Salary${this.modifier}`];
    },
    salaryHelpMessage() {
      return this.modifier === '' ? 'Put in your total yearly salary (before-tax) that your super contributions are based on. If you work for the QLD Government, the calculator assumes that both your employer and standard member contributions are based on this total salary which includes shift loading and allowances. Therefore, the estimates generated by this calculator may not be accurate for your situation. Check the calculator limitations for more information.' : 'Put in your partner\'s total yearly salary (before-tax) that their super contributions are based on. If they work for the QLD Government, the calculator assumes that both their employer and standard member contributions are based on this total salary which includes shift loading and allowances. Therefore, the estimates generated by this calculator may not be accurate for their situation. Check the calculator limitations for more information.';
    },
    salaryChanged() {
      return this.isNotWorking && this.hasNotChangedSalary;
    },
    salaryLowIncome() {
      return this.Salary.value <= Constants.ASFA_COMFORTABLE_LIVING_SINGLE;
    },
    salaryError() {
      return this.salaryLowIncome || this.salaryChanged;
    },
    salaryErrorMessage() {
      let message = '';

      if (this.salaryChanged) message += 'Because you’re not working, your annual salary has been defaulted to $0.';
      else if (this.salaryLowIncome) message += 'The calculation will assume you are eligible for the Government\'s low income superannuation contribution.';

      return message;
    },
    isNotWorking() {
      return !this.inputs[`Working${this.modifier}`].value;
    },
    hasNotChangedSalary() {
      return !this.inferred[`HasChangedSalary${this.modifier}`].value;
    },
  },
  methods: {
    ...mapActions([
      'actionAgeNow',
      'actionSex',
      'actionSalary',
    ]),
    setAgeNow(value) {
      this.actionAgeNow({ value, modifier: this.modifier });
    },
    setSex(value) {
      this.actionSex({ value, modifier: this.modifier });
    },
    setSalary(value) {
      this.actionSalary({ value, modifier: this.modifier });
    },
  },
};
</script>
